import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { WorkpaperCertification } from '../types/workpaper';

type GetWorkpaperCertificationParams = {
    overview: boolean;
};

type GetWorkpaperCertificationResponse = {
    certification: WorkpaperCertification;
};
async function getWorkpaperCertification(id: string, params: GetWorkpaperCertificationParams): Promise<GetWorkpaperCertificationResponse> {
    const { data } = await api.get(`/workpapers/${id}/certification`, { params });
    return data;
}

export function useWorkpaperCertification(
    id?: string,
    params: GetWorkpaperCertificationParams = { overview: false }
): UseQueryResult<GetWorkpaperCertificationResponse, unknown> {
    return useQuery(['workpapers', id, 'certification', ...Object.values(params)], () => getWorkpaperCertification(id as string, params), {
        keepPreviousData: true,
        enabled: Boolean(id),
    });
}
